import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { ReactElement, useContext } from "react";

import LayoutSwitcher from "../../components/layout-switcher/layout-switcher";
import Search from "../../components/search/search";
import UploadModal from "../../components/upload-modal/upload-modal";
import useText from "../../hooks/use-text";
import Navigation from "../../layout/navigation";
import { FilesContext } from "../../providers/files-provider";
import { LocalizedStrings, SupportedLanguages } from "../../utils/lang";

export const DEFAULT_LIMITS = [16, 32, 64, 128];

export default function FileListOperators(): ReactElement {
  const { limit, setLimit, setPage } = useContext(FilesContext);

  const { strings } = useText(local);

  function internalChangeLimit(limit: number): void {
    setPage(1);
    setLimit(limit);
  }

  return (
    <Navigation>
      <Search label={strings.search.label} />
      <FormControl className="w-[110px]">
        <InputLabel
          className="top-[16px]"
          id="demo-simple-select-autowidth-label"
        >
          {strings.limit.label}
        </InputLabel>
        <Select
          sx={{
            "& .MuiOutlinedInput-notchedOutline": { border: 0 },
            "& legend span": { width: 0, padding: 0 },
            "& .MuiSelect-select": {
              paddingTop: "25px",
              paddingBottom: "8px",
            },
          }}
          className="shadow rounded-[15px] bg-white overflow-hidden h-full border-none"
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          value={limit.toString()}
          onChange={(v) => internalChangeLimit(parseInt(v.target.value))}
          label={strings.limit.label}
        >
          {DEFAULT_LIMITS.map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <LayoutSwitcher />
      <UploadModal />
    </Navigation>
  );
}

type LocalSchema = {
  limit: {
    label: string;
  };
  search: {
    label: string;
  };
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    limit: {
      label: "Show",
    },
    search: {
      label: "Search in files",
    },
  },
};
